module.exports = __webpack_public_path__ + "96e92fa3e413666b98e96ee87e8f1e21.jpg";